// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "subsite-china/954-2e7d13e916ddc8d6a0de.js";
	if (chunkId === 532) return "subsite-china/styles-4eaeceb620afdd1ebc91.js";
	if (chunkId === 351) return "subsite-china/commons-e032b8e1c296f71fbfc6.js";
	if (chunkId === 875) return "subsite-china/190f48e1d712abf1b23afe7d98d0424ba15cabee-df0527e945a39bc02a29.js";
	if (chunkId === 218) return "subsite-china/component---src-pages-404-tsx-4dd35911cc1b65aede92.js";
	if (chunkId === 278) return "subsite-china/b0c88c5e5b54854a066ab8be45f25781c5307858-ac5d101783a38bd15cf8.js";
	if (chunkId === 904) return "subsite-china/2d1c9d34d7cabdcdf27eb8ffad16bade3b93f9b1-656e5eadbd258205fe2f.js";
	if (chunkId === 660) return "subsite-china/component---src-templates-personal-area-calendar-page-index-tsx-cd28edb25a4151c15e27.js";
	if (chunkId === 456) return "subsite-china/8bd7444894d603c816394f87921cda61ce72b74b-f258c58a456dc4516c7b.js";
	if (chunkId === 874) return "subsite-china/component---src-templates-personal-area-profile-page-index-tsx-3d6360464df40c050513.js";
	if (chunkId === 323) return "subsite-china/component---src-templates-qr-index-tsx-b13b59204e54ee4f3dea.js";
	if (chunkId === 77) return "subsite-china/component---src-templates-search-page-index-tsx-4b75fca1ac819a2fc41e.js";
	if (chunkId === 737) return "subsite-china/fb7d5399-f0825176b58310f1d901.js";
	if (chunkId === 863) return "subsite-china/072d4843-a362a6407b668449bf7e.js";
	if (chunkId === 208) return "subsite-china/2aacc723-f9bc2d6b4930ac91695b.js";
	if (chunkId === 344) return "subsite-china/bf322c48-375f2b4b76ba7e6d711a.js";
	if (chunkId === 811) return "subsite-china/22e32791-0009948c9264cc85b11d.js";
	if (chunkId === 312) return "subsite-china/409a021e-6ff25a6209bde9f9ae73.js";
	if (chunkId === 125) return "subsite-china/b2d36f25-7dd350e832dd7c2c47e2.js";
	if (chunkId === 255) return "subsite-china/7d0bf13e-216ab86eca633343cb3f.js";
	if (chunkId === 330) return "subsite-china/component---src-templates-standard-page-index-tsx-21ec00702cd6c89f92e0.js";
	if (chunkId === 731) return "subsite-china/731-7e694e4bbc6d5c640967.js";
	if (chunkId === 843) return "subsite-china/843-55dd20ce04b2f1730662.js";
	// return url for filenames based on template
	return undefined;
};